<template>
  <div>
    <p class="cm-mg-p-wzd">1.1 {{ $t('audit.audit_general_information') }}</p>
    <hr />
    <div class="row">
      <div class="col-12 col-sm-6 col-lg-3">
        <fg-input
          type="text"
          :label="`${$t('common_words.name')}: *`"
          v-model="model.name"
          name="common_words.name"
          v-validate="modelValidations.name"
          :error="getError('common_words.name', true)"
          :placeholder="`${$t('audit.audit_name')}...`"
        ></fg-input>
      </div>
      <select-component
        :dataOptions="types"
        :isMultiple="false"
        :initialSelection="model.catch_type"
        @onChange="handleChangeSelect"
        :labelSelect="`${$t('audit.type')}: *`"
        modelName="catch_type"
        requireClass="required-catch-type"
        rowClass="col-12 col-sm-6 col-lg-3"
      />
      <select-component
        :dataOptions="calificationTypes"
        :isMultiple="false"
        :initialSelection="model.calification_type"
        @onChange="handleChangeSelect"
        :labelSelect="`${$t('common_words.type_grade')}: *`"
        modelName="calification_type"
        requireClass="required-calification-type"
        rowClass="col-12 col-sm-6 col-lg-3"
      />
      <select-component
        :dataOptions="auditTypes"
        :isMultiple="false"
        :initialSelection="model.audit_type"
        @onChange="handleChangeSelect"
        :labelSelect="`${$t('common_words.type_of_capture')}: *`"
        modelName="audit_type"
        requireClass="required-audit-type"
        rowClass="col-12 col-sm-6 col-lg-3"
      />
    </div>
    <div class="row">
      <div class="col-12">
        <div class="form-group has-label">
          <label>{{ $t('common_words.description') }}:</label>
          <br />
          <el-input
            maxlength="500"
            show-word-limit
            type="textarea"
            :rows="2"
            placeholder="..."
            v-model="model.description"
            class="shadow-sm"
          ></el-input>
          <br />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <select-businesses-component
          :showLoading="true"
          @showHideLoading="showHideLoading"
          @onChange="handleBusinesses"
        />
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-6">
        <div class="form-group has-label">
          <label>{{ $t('common_words.record_selected_profiles') }}:</label>
          <br />
          <el-select
            collapse-tags
            @change="selectAllFromSelect('model.roles_id', availableRoles)"
            multiple
            clearable
            filterable
            class="select-primary custom-width-select shadow-sm"
            size="large"
            v-model="model.roles_id"
            :placeholder="`${$t('common_words.select2')}...`"
          >
            <el-option
              v-for="option in availableRoles"
              class="select-primary selected-all"
              :value="option.id"
              :label="option.name"
              :key="option.id"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="col-6">
        <div class="form-group has-label">
          <label>{{ $t('common_words.record_selected_users') }}:</label>
          <br />
          <el-select
            collapse-tags
            @change="selectAllFromSelect('model.users_id', availableUsers)"
            multiple
            clearable
            filterable
            class="select-primary custom-width-select shadow-sm"
            size="large"
            v-model="model.users_id"
            :placeholder="`${$t('common_words.select2')}...`"
          >
            <el-option
              v-for="option in availableUsers"
              class="select-primary selected-all"
              :value="option.id"
              :label="`${option.name}`"
              :key="option.id"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import i18n from 'src/i18n';
import MixinForm from 'src/mixins/forms/mixin-form';
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import store from '@/store';
import SweetAlert from 'src/class/Alerts';
import SelectClass from 'src/class/SelectClass';

export default {
  data() {
    return {
      model: {
        name: null,
        description: null,
        catch_type: null,
        calification_type: null,
        audit_type: 'web',
        businesses_id: [],
        roles_id: [],
        users_id: [],
      },
      modelValidations: {
        name: {
          required: true,
        },
      },
      businesses: [],
      roles: [],
      users: [],
      change_type: false,
      change_typec: false,
      selectClass: new SelectClass(this),
    };
  },
  mixins: [MixinPermissions, MixinForm, mixinMasters],
  computed: {
    availableRoles() {
      const tmp = [...this.model.roles_id];
      if (this.model.businesses_id.length > 0) {
        this.model.roles_id = [];
        const response = this.roles.filter((rol) => {
          const businessAffiliates = rol.business.filter((bs) =>
            this.model.businesses_id.includes(bs.id)
          );
          return businessAffiliates.length > 0;
        });

        response.forEach((rol) => {
          if (tmp.includes(0)) this.model.roles_id.push(rol.id);
          else if (tmp.includes(rol.id)) this.model.roles_id.push(rol.id);
        });

        return this.concatAll(response);
      } else return this.concatAll([]);
    },
    availableUsers() {
      const tmp = [...this.model.users_id];
      if (this.model.businesses_id.length > 0) {
        this.model.users_id = [];
        const response = this.users.filter((user) => {
          const businessAffiliates = user.business.filter((bs) =>
            this.model.businesses_id.includes(bs.id)
          );
          return businessAffiliates.length > 0;
        });

        response.forEach((user) => {
          if (tmp.includes(0)) this.model.users_id.push(user.id);
          else if (tmp.includes(user.id)) this.model.users_id.push(user.id);
        });

        return this.concatAll(response);
      } else return this.concatAll([]);
    },
    auditTypes() {
      return [
        { id: 'web', name: i18n.t('common_words.web') },
        { id: 'mobile', name: i18n.t('common_words.mobile') },
        { id: 'both', name: i18n.t('common_words.both') },
      ];
    },
    types() {
      return [
        { id: '1', name: i18n.t('common_words.per_farm') },
        { id: '2', name: i18n.t('common_words.per_allotment') },
      ];
    },
    calificationTypes() {
      return [
        { id: '1', name: i18n.t('common_words.objective_fem') },
        { id: '2', name: i18n.t('common_words.subjective_fem') },
      ];
    },
  },
  watch: {
    '$i18n.locale': ['getSelectAll'],
  },
  methods: {
    handleBusinesses(data) {
      this.selectClass.updateSelectedBusinesses(data);
    },
    handleChangeSelect(data) {
      this.selectClass.handleChangeSelected(data);
    },
    getSelectAll() {
      this.businesses = this.concatAll(this.businesses.splice(1));
    },
    validate() {
      return this.$validator.validateAll().then((res) => {
        if (res) {
          if (!this.model.catch_type)
            return store.dispatch(
              'utils/validationInputsRequired',
              '-catch-type'
            );
          if (!this.model.calification_type)
            return store.dispatch(
              'utils/validationInputsRequired',
              '-calification-type'
            );
          if (!this.model.audit_type && this.model.audit_type.length == 0)
            return store.dispatch(
              'utils/validationInputsRequired',
              '-audit-type'
            );
          if (this.model.businesses_id.length == 0)
            return store.dispatch(
              'utils/validationInputsRequired',
              '-bus-rels'
            );

          this.$emit('on-validated', res, this.model);

          let others = [];
          this.model.businesses_id.map((businessId) =>
            this.businesses.map(
              ({ id, name }) => businessId === id && others.push(name)
            )
          );

          const othersRoles = [];
          this.model.roles_id.map((roleId) =>
            this.roles.map(
              ({ id, name }) => roleId === id && othersRoles.push(name)
            )
          );

          const othersUsers = [];
          this.model.users_id.map((userId) =>
            this.users.map(
              ({ id, first_name, last_name, username }) =>
                userId === id &&
                othersUsers.push(`${first_name} ${last_name} (${username})`)
            )
          );

          this.$emit('fillAuditForm', 'firstStep', {
            business_name: others,
            roles_name: othersRoles,
            users_name: othersUsers,
            type: this.model.catch_type == 1 ? 'Por Finca' : 'Por Lote',
            type_calification:
              this.model.calification_type == 1 ? 'Objetiva' : 'Subjetiva',
            audit_type_label: this.auditTypes.find(
              (item) => item.id == this.model.audit_type
            ).name,
          });
          return res;
        }
      });
    },
  },
  created() {
    this.showHideLoading(true);
    if (this.isCreate() || this.isUpdate()) {
      Promise.all([
        Axios.getMasters('businesses/only'),
        Axios.getMasters('roles/indexfield'),
        Axios.getMasters('users/indexfield'),
      ])
        .then((response) => {
          const [response_business, response_roles, response_users] = response;
          this.businesses = this.concatAll(response_business.data.data);
          this.roles = response_roles.data.data;
          this.users = response_users.data.data;

          let editForm = {};
          if (this.isUpdate() && sessionStorage.getItem('editForm')) {
            editForm = JSON.parse(sessionStorage.getItem('editForm'));
            this.model.name = editForm.name;
            this.model.description = editForm.description;
            this.model.catch_type = editForm.catch_type;
            this.model.calification_type = editForm.calification_type;
            this.model.audit_type = editForm.audit_type;
            this.change_type = editForm.change_type;
            this.change_typec = editForm.change_typec;
            this.model.businesses_id = editForm.businesses_ids;
            this.model.roles_id = editForm.roles_id;
            this.model.users_id = editForm.users_id;
          }

          if (sessionStorage.getItem('editForm') === null) {
            this.model.businesses_id = this.selectElementsAsignFromModel(
              1,
              this.model.businesses_id,
              this.businesses
            );
            this.model.businesses_id === null &&
              this.businesses.length == 1 &&
              this.model.businesses_id.push(this.businesses[0].id);
          }

          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else this.showHideLoading();
  },
};
</script>
<style></style>
